import React, { useState } from 'react';
import { Dropdown, Icon } from 'antd';
import CheckMarkMenu from '../../../CheckMarkMenu/CheckMarkMenu';
import DispexButton from '../../../DispexButton/DispexButton';
import { calendarSelectTypes } from '../../constants';
import styles from './CalendarSelect.module.scss';

const CalendarSelect = ({
  items,
  currentDate,
  type = calendarSelectTypes.year,
  onDateChange,
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleMenuClick = (item) => {
    const newDate = currentDate.clone()[type](item.id);
    onDateChange(newDate);
    setDropdownVisible(false);
  };

  const handleVisibleChange = (visible) => {
    setDropdownVisible(visible);
  };

  return (
    <Dropdown
      trigger={['click']}
      visible={dropdownVisible}
      onVisibleChange={handleVisibleChange}
      placement="bottomRight"
      overlay={
        <CheckMarkMenu
          items={items}
          selectedItems={[currentDate.get(type)]}
          renderContent={(item) => item.name}
          visible={dropdownVisible}
          handlers={{
            onMenuClick: handleMenuClick,
          }}
        />
      }
    >
      <DispexButton type="primary" className={styles.button}>
        {currentDate.format(type === calendarSelectTypes.year ? 'YYYY' : 'MMM')}
        <Icon type={dropdownVisible ? 'caret-up' : 'caret-down'} />
      </DispexButton>
    </Dropdown>
  );
};

export default CalendarSelect;
